import * as CDs from "../../utility/commonColDef";

export const RegionColumnDefinitionForAdmin = [
  { ...CDs.RegionColDef("RegionName"), valueType: "region" },
  {
    ...CDs.Enabled,
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  { headerName: "TicketAssignTo", field: "TicketAssignTo", isEditable: true },
  { headerName: "TicketChannel", field: "TicketChannel", isEditable: true },
  { headerName: "ConstraintNote", field: "ConstraintNote", isEditable: true, valueType: "textarea" },
  {
    headerName: "Flighting",
    field: "IsFlighting",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  {
    headerName: "Enabled in UI",
    field: "EnabledInUI",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  { headerName: "SkipAutoApproval", field: "SkipAutoApproval", isEditable: true, valueType: "skipAutoApproval" },
  {
    headerName: "EnabledForCustomerEA",
    field: "EnabledForCustomerEA",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  {
    headerName: "EnabledBetOnDemand",
    field: "EnabledBetOnDemand",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  {
    headerName: "IsCappedForCapacityOrder",
    field: "IsCappedForCapacityOrder",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  {
    headerName: "EnableGrowthBlueprintAssignment",
    field: "EnableGrowthBlueprintAssignment",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  {
    headerName: "Default PSL",
    field: "DefaultPSL",
    cellRenderer: (params) => {
      return params.value
        ? '<a href="https://psl.azure.com/mapped-items/' + params.value + '" target="_blank" rel="noopener noreferrer">' + params.value + "</a>"
        : "";
    },
    isEditable: true,
    valueType: "number",
  },
];

export const AZConfigColumnDefinitionForAdmin = [
  { headerName: "AZ Name", field: "AvailabilityZoneName", valueType: "az" },
  { headerName: "Region Id", field: "RegionId", isEditable: false, valueType: "regionName" },
  {
    headerName: "IsEnabled",
    field: "IsEnabled",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
];

export const EdgeZoneColumnDefinitionForAdmin = [
  { ...CDs.EdgeZoneColDef("EdgeZoneId"), valueType: "edgezone" },
  {
    headerName: "EnabledBetOnDemand",
    field: "EnabledBetOnDemand",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
];

export const DefaultColumnDefinitionForAdmin = {
  resizable: true,
  sortable: true,
  filter: "agSetColumnFilter",
  tooltipComponent: "customTooltip",
  cellDataType: false,  // Disable automatic checkbox rendering for boolean values
};

export const AutoApprovalRuleColumnDefinitionForAdmin = [
  { ...CDs.Id, valueType: "number", hide: true },
  { ...CDs.RequestServiceType, valueType: "serviceType" },
  { ...CDs.SubscriptionType, wildcard: true, valueType: "internal" },
  { ...CDs.RequestSource, wildcard: true, valueType: "requestSource" },
  { ...CDs.ApprovalType, valueType: "approvalType" },
  { ...CDs.RegionColDef("Region"), wildcard: true, valueType: "region" },
  { ...CDs.Quota, isEditable: true, valueType: "number" },
];

export const AutoApprovalThresholdColumnDefinitionForAdmin = [
  { ...CDs.Id, valueType: "number", hide: true },
  {
    ...CDs.RequestServiceType,
    valueType: "serviceType",
    hide: false,
    cellRenderer: (params) => {
      return params.context.dataTypes.serviceTypeMap[params.value] || params.value;
    },
  },
  {
    headerName: "SKU",
    field: "Sku",
    wildcard: true,
    valueType: "sku",
    hide: false,
    cellRenderer: (params) => {
      if (params.value in params.context.dataTypes.skuMap) {
        return params.context.dataTypes.skuMap[params.value];
      } else {
        return params.value;
      }
    },
  } as any,
  { headerName: "Location", field: "Location", valueType: "location", hide: false },
  { ...CDs.Threshold, isEditable: true, valueType: "number", hide: false },
];

export const UserRoleColumnDefinitionForAdmin = [
  { headerName: "Role", field: "Role", valueType: "roles" },
  { headerName: "UPN", field: "Upn", valueType: "upn" },
  { headerName: "Regions", field: "Regions", isEditable: true, wildcard: true, valueType: "region" },
  { headerName: "Types", field: "Types", isEditable: true },
];

export const ManatreeColumnDefinitionForAdmin = [
  { headerName: "ManatreeName", field: "ManatreeName", valueType: "string" },
  { headerName: "ServiceTreeId", field: "ServiceTreeId", valueType: "Teams" },
];

export const ConfigColumnDefinitionForAdmin = [
  { ...CDs.Id, valueType: "number", hide: true },
  { headerName: "ConfigName", field: "ConfigKey" },
  { headerName: "ConfigType", field: "ConfigType" },
  { headerName: "Value", field: "Value", isEditable: true },
  { headerName: "Flighting Value", field: "FlightingValue", isEditable: true },
];

export const ServiceHandlingColumnDefinitionForAdmin = [
  { ...CDs.Id, valueType: "number", hide: true },
  { headerName: "Region", field: "ConfigType", valueType: "region" },
  { headerName: "Service Type", field: "ConfigKey", valueType: "serviceType" },
  { headerName: "Handling", field: "Value", isEditable: true, valueType: "serviceHandling", isNullable: true },
  { headerName: "Flighting Value", field: "FlightingValue", isEditable: true, valueType: "serviceHandling", isNullable: true },
];

export const AzColumnDefinitionForAdmin = [
  { headerName: "AZ Name", field: "AvailabilityZoneName", isRequired: true },
  { headerName: "Region Name", field: "DisplayRegionName" },
  { headerName: "Region DCMT Id", field: "RegionName" },
  { headerName: "DCMT Region Id", field: "DCMTRegionId", isRequired: true },
  { headerName: "Business Lifecycle", field: "BusinessLifecycle", isEditable: true },
  { headerName: "State", field: "State", isEditable: true },
  {
    headerName: "IsLive",
    field: "IsLive",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  {
    headerName: "Is supported in Geneva Action",
    field: "IsSupportedInGenevaAction",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  { headerName: "AFEC flag", field: "RequiredFeature", isEditable: true },
];

export const HdiSkuColumnDefinitionForAdmin = [
  { headerName: "Region Name", field: "RegionName", isRequired: true },
  { headerName: "CrpVmSku", field: "CrpVmSku", isRequired: true },
];

export const BatchSkuColumnDefinitionForAdmin = [
  { headerName: "Region Name", field: "RegionName", isRequired: true },
  { headerName: "CrpVmSku", field: "CrpVmSku", isRequired: true },
];

export const ServiceReadinessColumnDefinitionForAdmin = [
  { headerName: "Region Name", field: "Region", valueType: "region", isRequired: true },
  { headerName: "Service", field: "Service", valueType: "serviceType", isRequired: true },
  {
    headerName: "Is service ready",
    field: "IsServiceReady",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
];

export const ServiceReadinessStageColumnDefinitionForAdmin = [
  { headerName: "Service", field: "Service", valueType: "serviceType", isRequired: true },
  { headerName: "Region Name", field: "Region", valueType: "region", isRequired: true },
  { ...CDs.Stage, isRequired: true },
  { headerName: "Updated time", field: "UpdatedTime", isEditable: true },
];

export const SqlColumnDefinitionForAdmin = [
  { headerName: "Region Name", field: "Region", valueType: "region", isRequired: true },
  { headerName: "Sql Regional Feature Value", field: "SqlRegionalFeatureValue", isEditable: true },
];

export const ArmResourceTypeColumnDefinitionForAdmin = [
  { headerName: "Namespace", field: "Namespace", isRequired: true },
  { headerName: "Resource Type Name", field: "ResourceTypeName", isRequired: true },
  { headerName: "Location", field: "Location", isRequired: true },
  { headerName: "Feature To Assign", field: "FeatureToAssign", isEditable: true },
  { headerName: "Required Features", field: "RequiredFeatures", isEditable: true },
  { headerName: "Required Features Policy", field: "RequiredFeaturesPolicy", isEditable: true },
  { headerName: "Endpoint Uri", field: "EndpointUri", isEditable: true },
];

export const VmDiskColumnDefinitionForAdmin = [
  { headerName: "Disk Quota Type Name", field: "QuotaName" },
  { headerName: "Disk Quota Type", field: "QuotaType" },
  { headerName: "Max Disk Quota Limit", field: "MaxQuotaLimit", valueType: "number" },
  { headerName: "Location", field: "Location" },
];

export const VmSkuColumnDefinitionForAdmin = [
  { headerName: "Region Name", field: "RegionName", isRequired: true },
  { headerName: "CrpVmSku", field: "CrpVmSku", isRequired: true },
  {
    headerName: "Supported In Crp",
    field: "SupportedInCrp",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  {
    headerName: "Is Internal",
    field: "IsInternal",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
  },
  { headerName: "Required Features", field: "RequiredFeatures", isEditable: true },
];

export const PfSkuColumnDefinitionForAdmin = [
  { headerName: "Sku", field: "Sku", isRequired: true },
  { headerName: "Type", field: "Type", isEditable: true },
  { headerName: "Is Deleted", field: "IsDeleted", valueType: "boolean", isEditable: true, cellEditor: "agSelectCellEditor", cellEditorParams: { values: ["true", "false"] } },
  { headerName: "Last Updated Time", field: "LastUpdatedTime" },
  { headerName: "Last Updated By", field: "LastUpdatedBy" },
];

export const RegionTableColumnDefinitionForAdmin = [
  { ...CDs.RegionColDef("RegionName"), valueType: "region" },
  { headerName: "Status", field: "Status", valueType: "status" },
  { headerName: "MA Launch Date", field: "MALaunchDate", valueType: "maLaunchDate" },
  { headerName: "PSL", field: "PSL" },
  { headerName: "Cloud Name", field: "CloudName", valueType: "cloudName" },
  { headerName: "Arm Region Name", field: "ArmRegionName", valueType: "armRegionName" },
  { headerName: "Short Id", field: "ShortId", valueType: "shortId" },
  { headerName: "Dcmt Id", field: "DcmtId", valueType: "dcmtId" },
  { headerName: "Dcmt Region Id", field: "DCMTRegionId", valueType: "dcmtRegionId" },
  { headerName: "Region Type", field: "RegionType", valueType: "RegionType" },
  { headerName: "Current Architecture", field: "CurrentArchitecture", valueType: "currentArchitecture" },
  { headerName: "Required Features", field: "RequiredFeatures" },
  { headerName: "Centralized Arm Feature Flag", field: "CentralizedArmFeatureFlag", valueType: "centralizedArmFeatureFlag" },
  { headerName: "Buildout Arm Feature Flag", field: "BuildoutArmFeatureFlag", valueType: "buildoutArmFeatureFlag" },
  { headerName: "Customer Arm Feature Flag", field: "CustomerArmFeatureFlag", valueType: "customerArmFeatureFlag" },
  { headerName: "AZ Feature Flag", field: "AZFeatureName", valueType: "AZFeatureName" },
  { headerName: "Zone Resilience Support", field: "ZoneResilienceSupport" },
  { headerName: "Is capacity order supported", field: "IsCapacityOrderSupported", valueType: "isCapacityOrderSupported"},
];

export const ProjectColumnDefinitionForAdmin = [
  { ...CDs.ProjectOidColDef("ProjectOid") },
  { headerName: "Project Name", field: "Title", isEditable: true, isRequired: true },
  { headerName: "RegionOid", field: "RegionOid", isRequired: true },
  { headerName: "Project Status", field: "ProjectStatus", isEditable: true },
  { headerName: "Plan Type", field: "PlanType", isEditable: true },
  { headerName: "Project Type", field: "ProjectType", isEditable: true },
  { headerName: "PSL", field: "PSL", isEditable: true, valueType: "number" },
  { headerName: "MA Launch Date", field: "MALaunchDate", isEditable: true },
  { headerName: "Project Architecture", field: "ProjectArchitecture", isEditable: true },
  { headerName: "Opportunity Type", field: "OpportunityType", isEditable: true },
  CDs.CreatedBy,
  CDs.CreatedTime,
];

export const BlueprintConfigColumnDefinitionForAdmin = [
  {
    headerName: "Service Team Name",
    field: "ServiceTreeId",
    valueType: "Teams",
    cellRenderer: (params) => {
      return `${params.context.dataTypes.teamNameOidMap[params.data.ServiceTreeId]}(${params.data.ServiceTreeId})`;
    },
  },
  {
    headerName: "Blueprint",
    field: "Blueprint",
    valueType: "blueprint",
  },
  {
    headerName: "Region Name",
    field: "Region",
    default: "*",
    valueType: "region",
  },
  {
    headerName: "New Region Auto Assign",
    field: "NewRegionAutoAssign",
    isEditable: true,
    cellEditor: "agSelectCellEditor",
    cellEditorParams: {
      values: ["true", "false"],
    },
    valueType: "boolean",
    default: false,
  },
];
